// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"fb561536","938":"0a8620ab"}[chunkId] + ".chunk.css";
};